import { Workspace, CoreWorkspaceStatus } from 'src/app/interfaces/workspace.interface';
import { MAX_FAILOVER_DEPTH, MAX_CHAIN_DEPTH } from 'src/environments/environment';

/**
 * Workspace Constants
 */

/** Resolution of the grid (length of one grid square in px) */
export const GRID_SIZE = 43;

export const EMPTY_WORKSPACE: Workspace = {
	nodes: [],
	bands: [],
	workflows: [],
};

/**
 * Invalid configurations
 */

const sep = '_______________________ ';

export const DEEP_NODES_STATUS: CoreWorkspaceStatus = {
	valid: false,
	modified: true,
	message: $localize`Maximum chaining depth is ${MAX_CHAIN_DEPTH + 2} and maximum failover depth is ${
		MAX_FAILOVER_DEPTH + 2
	}. Remove nodes exceeding these depths before saving the workspace. ${sep}`,
};

export const MULTIPLE_WORKFLOWS_STATUS: CoreWorkspaceStatus = {
	valid: false,
	modified: true,
	message: $localize`You have created more than one workflow. All triggers and actions must be connected to form a single workflow. Either delete one of them, or combine them into a single workflow. Additional workflows can be created from the dashboard. ${sep}`,
};

export const NO_WORKFLOWS_STATUS: CoreWorkspaceStatus = {
	valid: false,
	modified: true,
	message: $localize`You have no workflows in this workspace. If you want to delete this workflow, discard changes and press the delete button. ${sep}`,
};

export const UNREACHABLE_NODES_STATUS: CoreWorkspaceStatus = {
	valid: false,
	modified: true,
	message: $localize`You have actions which are not reachable from a trigger, or a trigger with no actions. Delete or connect them before saving. ${sep}`,
};

/**
 * Valid configurations
 */
export const INITIAL_STATUS: CoreWorkspaceStatus = {
	valid: true,
	modified: true,
	message: $localize`Initial status. ${sep}`,
};

// Workspace is valid but has not been changed since last save
export const ALREADY_SAVED_STATUS: CoreWorkspaceStatus = {
	valid: true,
	modified: false,
	message: $localize`All changes are saved. ${sep}`,
};

// Workspace is valid and can be saved
export const VALID_SAVE_STATUS: CoreWorkspaceStatus = {
	valid: true,
	modified: true,
	message: $localize`Save all workflows. ${sep}`,
};

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
